<template>
  <public-layout>
    <template slot="main">
      <div class="w-full flex flex-col min-h-full dark:bg-staticdarkblue-900">
        <div class="flex flex-grow items-center justify-center mt-10">
          <div class="w-full max-w-sm relative">
              <div class="flex flex-row">
                <base-logo :filename="logo" alt="EdasNEO" class="mx-auto mb-6 w-logo brand"/>
              </div>
              <div>
                <div v-if="isFirstLogin">
                  <FirstLoginForm
                    @cleanToggleForms="cleanToggleForms" 
                    @activeLoginOTPConfig="activeLoginOTPConfig" 
                    @activeLoginOTP="activeLoginOTP"/>
                </div>
                <div v-else-if="isLoginOTP">
                  <OtpLoginForm
                    @cleanToggleForms="cleanToggleForms" />
                </div>
                <div v-else-if="isLoginOTPConfig">
                  <OtpConfigForm 
                    @cleanToggleForms="cleanToggleForms" 
                    @activeLoginOTP="activeLoginOTP"/>
                </div>
                <div v-else-if="isLogin">
                  <el-form
                    @submit.prevent.native="submitLoginForm()"
                    class="px-4 sm:px-0"
                    :model="loginForm"
                    :rules="loginRules"
                    ref="loginForm"
                    novalidate
                  >
                  <div>
                    <el-form-item prop="email">
                      <el-input
                        placeholder="Usuario / Email ..."
                        class="mb-2 custom__icons static-css"
                        v-model="loginForm.email"
                        maxlength='255'
                        :disabled="loginType !== null"
                        autocomplete="username"
                      >
                        <i slot="prefix" class="el-input__icon">
                          <BaseIcon size="sm" name="user" :ariaHidden="true" />
                        </i>
                        <template v-if="loginForm.email && !loginType" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de usuario o email"
                            @clear="loginForm.email = ''"
                          />
                        </template>
                        <el-button slot="append" icon="el-icon-edit" 
                          v-if="loginType != null"
                          @click="resetLoginType()"
                          aria-label="Editar nombre de usuario o email y restablecer formulario"
                          ></el-button>
                      </el-input>
                    </el-form-item>
                  </div>
                  <el-form-item  prop="password"
                    v-show="loginType === 'STANDARD' || loginType === 'HYBRID' || loginType === 'HYBRIDSAML2'"
                    class="mb-0"
                    >
                      <el-input
                        ref="passwordInput"
                        placeholder="Contraseña ..."
                        type="password"
                        class="mb-4 custom__icons static-css"
                        show-password
                        v-model="loginForm.password"
                        maxlength='50'
                      >
                        <i slot="prefix" class="el-input__icon">
                          <BaseIcon size="sm" name="lock" :ariaHidden="true" />
                        </i>
                        <template v-if="loginForm.password" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de contraseña"
                            @clear="loginForm.password = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
                  <div v-if="loginType && !(isFirstLogin || isLoginOTP || isLoginOTPConfig)">
                    <div class="flex items-center justify-end ">
                      <button class="block text-sm font-semibold text-staticprimary-800 dark:text-staticdarkblue-200 cursor-pointer hover:text-staticprimary"
                        style="max-width: 160px"
                        @click.prevent="switchForm()"
                        type="button"
                        >¿Olvidó la contraseña?</button>
                    </div>
                  </div>
                  <base-button
                    v-if="loginType === 'STANDARD' || loginType === 'HYBRID' || loginType === 'HYBRIDSAML2'"
                    class="w-full mt-4"
                    mode="staticprimary"
                    text="Acceder"
                    :loading="loader"
                    :disabled="loader"
                    :type="([SubmitType.LOGIN].includes(submitType) || ([SubmitType.MIXTO_AAD, SubmitType.MIXTO_SAML2].includes(submitType) && loginForm.password)) ? 'submit' : 'button'"
                    @click="([SubmitType.LOGIN].includes(submitType) || ([SubmitType.MIXTO_AAD, SubmitType.MIXTO_SAML2].includes(submitType) && loginForm.password)) ? empty() : doLogin('loginForm')"
                  />
                  <div class=" px-4 sm:px-0">
                <base-button 
                      v-if="[SubmitType.LOGIN_TYPE].includes(submitType)"
                      class="w-full mt-4"
                      mode="staticprimary"
                      text="Siguiente"
                      :loading="loader"
                      :disabled="loader"
                      :type="[SubmitType.LOGIN_TYPE].includes(submitType) ? 'submit' : 'button'"
                      @click="[SubmitType.LOGIN_TYPE].includes(submitType) ? empty() : handleGetLogInType('loginForm')"
                      />
                    <base-button 
                      v-if="loginType === 'AAD' || loginType === 'HYBRID'"
                      class="w-full mt-4"
                      mode="staticprimary"
                      text="Acceder con Microsoft"
                      icon="microsoft"
                      :loading="loader"
                      :disabled="loader"
                      :type="[SubmitType.AAD].includes(submitType) ? 'submit' : 'button'"
                      @click="[SubmitType.AAD].includes(submitType) ? empty() : logInMicrosoft()"
                      />
                    <base-button 
                      v-if="loginType === 'SAML2' || loginType === 'HYBRIDSAML2'"
                      class="w-full mt-4"
                      mode="staticprimary"
                      text="Acceder con SAML2"
                      icon="sso"
                      :loading="loader"
                      :disabled="loader"
                      :type="[SubmitType.SAML2].includes(submitType)"
                      @click="[SubmitType.SAML2].includes(submitType) ? empty() : logInSAML2()"
                      />
                  </div>
                  </el-form>
                </div>
                <div v-else-if="!isLogin">
                  <el-form
                    @submit.prevent.native="doReset('resetForm')"
                    class="px-4 sm:px-0"
                    :model="resetForm"
                    :rules="resetRules"
                    ref="resetForm"
                  >
                    <p class="text-sm mb-2 text-center text-secondary-600 dark:text-staticdarkblue-200">
                      Introduzca su correo de registro y le enviaremos las
                      instrucciones para resetear la contraseña.
                    </p>
                  <el-form-item  prop="email" class="mb-0">
                      <el-input
                        placeholder="Email de registro ..."
                        type="email"
                        class="mb-4 custom__icons static-css"
                        v-model="resetForm.email"
                        maxlength='255'
                        autocomplete="username"
                      >
                        <i
                          slot="prefix"
                          class="el-input__icon"
                        >
                          <base-icon name="user" />
                        </i>
                        <template v-if="resetForm.email" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de email de registro"
                            @clear="resetForm.email = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
                    <div v-if="loginType && !(isFirstLogin || isLoginOTP || isLoginOTPConfig)">
                      <div class="flex items-center justify-end ">
                        <button class="block text-sm font-semibold text-staticprimary-800 dark:text-staticdarkblue-200 cursor-pointer hover:text-staticprimary"
                          style="max-width: 165px"
                          @click.prevent="switchForm()"
                          type="button"
                        >Volver a inicio de sesión</button>
                      </div>
                    </div>
                    <base-button
                      mode="staticprimary"
                      text="Resetear contraseña"
                      class="w-full mt-4"
                      @click.prevent="doReset('resetForm')"
                      type="button"
                      :loading="loader"
                      :disabled="loader"
                    />
                  </el-form>
                </div>
              </div>
            <base-logo-partner
              class="mx-auto mb-6 mt-6 w-logozc brand"
              alt="ZeroComa"
              :filename="logoPartner"/>
          </div>
        </div>
      </div>
    </template>
  </public-layout>
</template>

<script>
import { getApiBaseUrl, joinUrl } from '@/config/runtimeConfig'
import PublicLayout from '@/components/layout/PublicLayout.vue'
import OtpLoginForm from '@/components/loginoptions/OtpLoginForm.vue'
import OtpConfigForm from '@/components/loginoptions/OtpConfigForm.vue'
import FirstLoginForm from '@/components/loginoptions/FirstLoginForm.vue'

import { getLoginType } from '@/services/configurations/getLoginType'

import { i18n } from '@/i18n'

const SubmitType = {
  NONE: 'none',
  LOGIN_TYPE: 'loginType',
  LOGIN: 'login',
  AAD: 'aad',
  SAML2: 'saml2',
  MIXTO_AAD: 'mixtoAad',
  MIXTO_SAML2: 'mixtoSaml2'
}

export default {
  components: { 
    PublicLayout,
    OtpLoginForm,
    OtpConfigForm,
    FirstLoginForm,
  },
  name: 'login',
  data: function () {
    return {
      SubmitType: SubmitType,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      loginForm: {
        email: '',
        password: ''
      },
      resetForm: {
        email: ''
      },
      isLogin: true,
      loader: false,
      // Tipos
      loginType: null,
      // OTP
      isFirstLogin: false,
      isLoginOTP: false,
      isLoginOTPConfig: false,
      // Rules and validation:
      loginRules: {
        email: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        password: [
          { validator: this.isPasswordValid, trigger: 'blur' }
        ]
      },
      resetRules: {
        email: [
          { validator: this.isEmailRegValid, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'edasneowhite.webp'
      }
      return 'edasneo.webp'
    },
    logoPartner: function () {
      if (this.darkMode) {
        return 'logo-zc-dark.webp'
      }
      return 'logo-zc.webp'
    },
    submitType: function () {
      if (!this.loginType) {
        return SubmitType.LOGIN_TYPE
      }
      if (['STANDARD'].includes(this.loginType)) {
        return SubmitType.LOGIN
      }
      if (this.loginType === 'AAD') {
        return SubmitType.AAD
      }
      if (this.loginType === 'SAML2') {
        return SubmitType.SAML2
      }
      if (this.loginType === 'HYBRID') {
        return SubmitType.MIXTO_AAD
      }
      if (this.loginType === 'HYBRIDSAML2') {
        return SubmitType.MIXTO_SAML2
      }
      return SubmitType.NONE
    }
  },
  mounted: function () {
    if (this.$route.params.refreshTokenFail === true) {
      this.doFeedback('Su sesión ha caducado, es necesario volver a iniciar sesión', 'info', 5000)
    }
    this.$store.commit('app/resetHaderCoreFilters')

    this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
      setTimeout(() => {
        this.fixAccesibilityElInputPassword(this.$refs.passwordInput, this.$i18n.t('aria.elementui.input.password'))
      }, 1000)
    })
  },
  methods: {
    cleanToggleForms () {
      this.isFirstLogin = false
      this.isLoginOTP = false
      this.isLoginOTPConfig = false
    },
    activeLoginOTP () {
      this.isLoginOTP = true
    },
    activeLoginOTPConfig () {
      this.isLoginOTPConfig = true
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      callback()
    },
    isEmailRegValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!this.reg.test(value)) {
        return this.doAriaLiveAndReturnCallback('El email no es correcto o está mal escrito', callback)
      } else {
        callback()
      }
    },
    isPasswordValid: function (rule, value, callback) {
      if (!this.loginType) {
        callback()
      }
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      callback()
    },
    switchForm: function () {
      this.isLogin = !this.isLogin
    },
    submitLoginForm: function () {
      const formName = 'loginForm'
      if (!this.loginType) {
        this.handleGetLogInType(formName)
      } else if (this.loginType === 'AAD') {
        this.logInMicrosoft()
      } else if (this.loginType === 'SAML2') {
        this.logInSAML2()
      } else {
        this.doLogin(formName)
      }
    },
    doLogin: async function (formName) {
      const valid = await this.$refs[formName].validate()
      if (valid) {
        try {
          this.loader = true
          await this.$store.dispatch('auth/login', this.loginForm)
          // this.$store.dispatch('auth/me', false)
          await this.$store.dispatch('auth/getModules')
          await this.$store.dispatch('auth/getPermisos')
          await this.$store.dispatch('app/getAnnouncementsList')
        } catch (error) {
          console.error(error)
          if (error !== undefined && error.blnError) {
            if (error.stepCode === 0) { 
              this.isFirstLogin = true
            } else if (error.stepCode === 2) {
              this.isLoginOTPConfig = true
            } else if (error.stepCode === 3) {
              this.isLoginOTP = true
            } else {
              this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
            }
          } else {
            this.doFeedback()
          }
        } finally {
          this.loader = false
        }
      } else {
        this.doFeedback('Usuario y/o contraseña incorrectos')
      }
    },
    doReset: async function (formName) {
      const valid = await this.$refs[formName].validate()
      if (valid) {
        try {
          this.loader = true
          await this.$store.dispatch('auth/recoveryPassword', this.resetForm)
          this.doFeedback('Se ha enviado un correo de recuperación', 'success')
          this.switchForm()
        } catch (error) {
          if (error !== undefined && error.blnError) {
            this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
          } else {
            this.doFeedback()
          }
        } finally {
          this.loader = false
        }
      } else {
        this.doFeedback('Email no válido')
      }
    },
    logInMicrosoft: async function () {
      this.loader = true
      try {
        this.$store.commit('aadAuth/settingUPMsal')
        await this.$store.dispatch('aadAuth/showPopUpLogin')
      } catch (error) {
        if (error !== undefined && error.blnError) {
          this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
        } else {
          this.doFeedback()
        }
      } finally {
        this.loader = false
      }
    },
    logInSAML2: async function () {
      this.loader = true
      try {
        const guidSSO = this.$store.getters['aadAuth/GuidSSO']
        window.location.href = joinUrl(getApiBaseUrl(), 'api/login/requestsaml2?guid=' + guidSSO)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.loader = false
      }
    },
    resetLoginType () {
      this.loginType = null
    },
    handleGetLogInType: async function (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            this.loader = true
            // Obtener datos de login
            const loginType = await getLoginType({ usernameOrEmail: this.loginForm.email })
            if (loginType.blnError) {
              throw loginType
            } else {
              this.loginType = loginType.TipoAutenticacion
              this.$store.commit('aadAuth/setClientID', loginType.ClientID)
              this.$store.commit('aadAuth/setTenantID', loginType.TenantID)
              this.$store.commit('aadAuth/setGuidSSO', loginType.Guid)
              if (this.loginType === 'AAD') this.logInMicrosoft()
              if (this.loginType === 'SAML2') this.logInSAML2()
            }
          } catch (error) {
            console.error(error)
            if (error !== undefined && error.blnError) {
              this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
            } else {
              this.doFeedback()
            }
          } finally {
            this.loader = false
          }
        } 
      })
    },
    empty: () => {
      // console.log('empty')
    },
  }
}
</script>
<style lang="scss" scoped>
.w-logozc {
  max-width: 180px;
}
.w-logo {
  max-width: 250px;
}

.dark .el-input .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>
